import { Project } from './types';

export const PROJECTS: Project[] = [
  {
    id: 'codex-infinity',
    title: 'Codex Infinity',
    subtitle: 'Autonomous coding-agent platform',
    description: 'Cloud fleet orchestration, GitHub integration, streamed agent sessions, CI repair loops, and multi-model coding workflows.',
    url: 'https://codex-infinity.com',
    technologies: ['Go', 'React', 'GitHub', 'AI Agents'],
    category: 'flagship',
    image: '/assets/codex-infinity.webp',
    color: 'from-sky-500 to-cyan-300',
  },
  {
    id: 'openpaths',
    title: 'OpenPaths',
    subtitle: 'OpenAI-compatible model gateway',
    description: 'Provider routing across chat, image, video, music, speech, transcription, and embeddings with reasoning controls and unified API shape.',
    url: 'https://openpaths.io',
    github: 'https://codex-infinity.com/lee101/openpaths',
    technologies: ['Go', 'LLMs', 'API Gateway', 'Routing'],
    category: 'flagship',
    image: '/assets/openpaths.svg',
    color: 'from-emerald-400 to-teal-500',
  },
  {
    id: 'cutedsl',
    title: 'CuteDSL',
    subtitle: 'AI acceleration and kernels',
    description: 'Custom CUDA/Triton kernels, fused model pipelines, Chronos-2 acceleration, and an API surface for fast AI inference and training.',
    url: 'https://cutedsl.app.nz',
    github: 'https://codex-infinity.com/lee101/cutedsl',
    technologies: ['CUDA', 'Triton', 'PyTorch', 'Compilers'],
    category: 'flagship',
    image: '/assets/cutedsl.webp',
    color: 'from-orange-400 to-red-500',
  },
  {
    id: 'netwrck',
    title: 'Netwrck',
    subtitle: 'AI media and community network',
    description: 'Social AI community with chatbots, stories, generated art, voices, and agent-style entertainment experiences.',
    url: 'https://netwrck.com',
    technologies: ['PyTorch', 'Hugging Face', 'Agents', 'Media'],
    category: 'flagship',
    image: '/assets/netwrck.webp',
    color: 'from-fuchsia-500 to-rose-500',
  },
  {
    id: 'ebank',
    title: 'eBank.nz Art Generator',
    subtitle: 'AI art generation and editing',
    description: 'HD diffusion outputs, prompt discovery, style workflows, image editing, and subscription-backed generation capacity.',
    url: 'https://ebank.nz',
    technologies: ['Diffusion', 'LoRA', 'CLIP', 'GPU Serving'],
    category: 'flagship',
    image: '/assets/ebank.webp',
    color: 'from-blue-500 to-indigo-500',
  },
  {
    id: 'text-generator',
    title: 'Text Generator',
    subtitle: 'Unified AI API and model stack',
    description: 'Text, speech, vision, code generation, prompt tooling, OCR/caption enrichment, and self-hostable model-serving infrastructure.',
    url: 'https://text-generator.io',
    github: 'https://github.com/TextGeneratorio/text-generator.io',
    technologies: ['LLMs', 'Speech', 'Vision', 'Model Serving'],
    category: 'flagship',
    image: '/assets/text-generator.webp',
    color: 'from-lime-400 to-emerald-500',
  },
  {
    id: 'dictatorflow',
    title: 'DictatorFlow',
    subtitle: 'Speech control and dictation',
    description: 'Desktop and browser dictation with hotkey recording, local GPU Parakeet ONNX transcription, cloud fallback, command mode, and transcript history.',
    url: 'https://dictatorflow.com',
    technologies: ['Speech', 'ONNX', 'GPU', 'Desktop'],
    category: 'innovation',
    image: '/assets/dictatorflow.webp',
  },
  {
    id: 'simplexgen',
    title: 'SimplexGen',
    subtitle: '3D generation and editing',
    description: 'Go-backed 3D generation app with Vite frontend, local asset indexing, mesh tools, generation queues, billing, and R2 storage.',
    url: 'https://simplexgen.com',
    technologies: ['Go', 'Three.js', '3D', 'R2'],
    category: 'innovation',
    image: '/assets/simplexgen.webp',
  },
  {
    id: 'etherealstorm',
    title: 'Ethereal Storm',
    subtitle: 'Go/Ebiten action game',
    description: 'Twin-stick bullet hell with co-op, procedural terrain, wave survival, bosses, spell combinations, progression, and dynamic audio.',
    url: 'https://etherealstorm.app.nz',
    technologies: ['Go', 'Ebiten', 'Game AI', 'Procedural'],
    category: 'innovation',
    image: '/assets/etherealstorm.webp',
  },
  {
    id: 'ring',
    title: 'Ring.nz',
    subtitle: 'Voice chat with AI friends',
    description: 'Voice and product communication experiments for real-time AI conversations and friend-like AI interaction.',
    url: 'https://ring.nz',
    technologies: ['Voice', 'Realtime', 'AI UX'],
    category: 'innovation',
    image: '/assets/ring.webp',
  },
  {
    id: 'gpubrain',
    title: 'GPUBrain',
    subtitle: '1ms instant GPU search',
    description: 'GPU-accelerated agent memory — sub-millisecond semantic + keyword retrieval at scale, MCP tools, knowledge graph links, and CLI workflows.',
    url: 'https://gobrain.app.nz',
    github: 'https://codex-infinity.com/lee101/gobrain',
    technologies: ['CUDA', 'Postgres', 'Embeddings', 'MCP'],
    category: 'innovation',
    image: '/assets/gobrain-brain-chip.webp',
  },
  {
    id: 'papers',
    title: 'Papers',
    subtitle: 'Research search engine',
    description: 'Search engine for papers, code, methods, datasets, and evals with semantic search, crawler jobs, GPU acceleration, and CUDA optimization.',
    url: '/papers',
    technologies: ['Search', 'CAGRA', 'CUDA', 'Crawlers'],
    category: 'innovation',
    image: '/assets/papers.webp',
  },
  {
    id: 'stock-prediction',
    title: 'Stock Prediction',
    subtitle: 'Market forecasting research',
    description: 'Auto-research and RL trading experiments over Alpaca/Binance, selector evaluation, Chronos-style forecasting, and realistic portfolio probes.',
    github: 'https://codex-infinity.com/lee101/stock-prediction',
    technologies: ['RL', 'Forecasting', 'Chronos', 'Backtests'],
    category: 'innovation',
    image: '/assets/stock-prediction.webp',
  },
  {
    id: 'helix',
    title: 'Helix',
    subtitle: 'AI data analyst',
    description: 'AI data scientist product for interpreting datasets, generating insights, and automating reporting with model-backed analysis workflows.',
    url: 'https://helix.app.nz',
    technologies: ['Analytics', 'LLMs', 'Reports'],
    category: 'innovation',
    image: '/assets/helix.webp',
  },
  {
    id: 'experimentflow',
    title: 'ExperimentFlow',
    subtitle: 'Online learning and RL platform',
    description: 'Neural contextual bandits, policy optimization, and continual personalization that keeps improving in production.',
    url: 'https://experimentflow.com',
    technologies: ['Bandits', 'RL', 'Optimization'],
    category: 'innovation',
    image: '/assets/experimentflow-icon.webp',
  },
  {
    id: 'hires',
    title: 'Hires.nz',
    subtitle: 'Recruitment and marketplace experiments',
    description: 'Recruitment/product experiments in the SimplexGen workspace with deployed web assets and Go-backed services.',
    technologies: ['Go', 'Marketplace', 'Recruitment'],
    category: 'innovation',
    image: '/assets/hires.webp',
  },
  {
    id: 'stable-diffusion-server',
    title: 'Stable Diffusion Server',
    subtitle: 'Production image generation server',
    description: 'Flux/SDXL, ControlNet, inpainting, R2/GCS storage, FastAPI, and Gradio tooling for production image generation.',
    github: 'https://github.com/netwrck/stable-diffusion-server',
    technologies: ['FastAPI', 'Flux', 'SDXL', 'ControlNet'],
    category: 'opensource',
    image: '/assets/netwrck.webp',
  },
  {
    id: 'gpubrain-search',
    title: 'GPUBrain Search Engine',
    subtitle: '1ms GPU-native retrieval',
    description: 'Open-source engine behind GPUBrain — Postgres-backed semantic search, BM25, RRF fusion, MCP server, REST API, and CLI.',
    github: 'https://codex-infinity.com/lee101/gobrain',
    technologies: ['Postgres', 'BM25', 'RRF', 'MCP'],
    category: 'opensource',
    image: '/assets/gobrain-brain-chip.webp',
  },
  {
    id: 'how',
    title: 'How.nz',
    subtitle: 'Technical writing archive',
    description: 'Programming, performance, networking, algorithms, graphics, and game-system design writing since 2015.',
    url: 'https://how.nz',
    technologies: ['Writing', 'Systems', 'Graphics'],
    category: 'classic',
    image: '/assets/how.webp',
  },
  {
    id: 'bitbank',
    title: 'BitBank.nz',
    subtitle: 'Live crypto forecasting',
    description: 'Cryptocurrency prediction dashboard using time-series transformers, RL trading policies, PufferLib agents, custom CUDA/C++ kernels, and Triton.',
    url: 'https://bitbank.nz',
    technologies: ['Chronos', 'TimesFM', 'RL', 'Triton'],
    category: 'classic',
    image: '/assets/bitbank.webp',
  },
  {
    id: 'stackhack',
    title: 'StackHack',
    subtitle: 'AI stack analysis',
    description: 'AI tech-stack analysis tool for breaking down websites, libraries, frameworks, and implementation choices with LLMs.',
    url: 'https://stackhack.netwrck.com',
    technologies: ['LLMs', 'NLP', 'Web Analysis'],
    category: 'classic',
    image: '/assets/stackhack.webp',
  },
  {
    id: 'websim',
    title: 'WebSim',
    subtitle: 'AI website simulator',
    description: 'Website simulator for generating and iterating web pages with language models, Python services, and browser tooling.',
    url: 'https://websim.netwrck.com',
    technologies: ['LLMs', 'Python', 'Browser Tooling'],
    category: 'classic',
    image: '/assets/websim.webp',
  },
  {
    id: 'mojojojo',
    title: 'mojojojo',
    subtitle: 'Python execution billed by the millisecond',
    description: 'Send Python, get output, pay for the milliseconds it ran. Numeric loops are transpiled to Mojo and cached so repeat kernels run natively; everything else is real CPython with uv-installed packages. Runs free in your browser via WebAssembly and only falls back to our machines when it needs a GPU or a package wasm cannot build. Signs in with your app.nz account and shared credits.',
    url: 'https://mojojojo.app.nz',
    technologies: ['Mojo', 'Go', 'WebAssembly', 'Serverless Compute'],
    category: 'classic',
    image: '/assets/mojojojo.webp',
  },
  {
    id: 'readingtime',
    title: 'Reading Time',
    subtitle: 'AI picture-book studio & reader',
    description: 'AI storytelling & reading app for kids. Generate fully illustrated picture books with your choice of story and image models, then read along as each word lights up. Signs in with your app.nz account and uses your shared credits.',
    url: 'https://readingtime.app.nz',
    technologies: ['Go', 'AI Story Gen', 'Image Models', 'Education'],
    category: 'classic',
    image: '/assets/readingtime.webp',
  },
  {
    id: 'big-multiplayer-chess',
    title: 'Big Multiplayer Chess',
    subtitle: 'Many-player chess variant',
    description: 'Large-board chess with move generation, game heuristics, AI evaluation, and mobile constraints.',
    url: 'https://bigmultiplayerchess.v5games.com',
    technologies: ['Python', 'Game AI', 'JavaScript'],
    category: 'classic',
    image: '/assets/big-multiplayer-chess.webp',
  },
  {
    id: 'webfiddle',
    title: 'WebFiddle',
    subtitle: 'Edit and share the web',
    description: 'Tool for modifying pages, storing the resulting state, and sharing the result back through a link.',
    url: 'https://webfiddle.net',
    technologies: ['Python', 'App Engine', 'JavaScript'],
    category: 'classic',
    image: '/assets/webfiddle.webp',
  },
  {
    id: 'reword',
    title: 'reWord',
    subtitle: 'Sentence puzzle game',
    description: 'Language puzzle game built with Python, Google App Engine, and JavaScript.',
    url: 'https://rewordgame.com',
    technologies: ['Python', 'JavaScript', 'Game'],
    category: 'classic',
    image: '/assets/rewordgame.webp',
  },
  {
    id: 'evangeler',
    title: 'Evangeler',
    subtitle: 'Viral marketing product',
    description: 'Campaign product with Python, Backbone, Facebook integrations, and viral campaign mechanics.',
    url: 'https://evangeler.com',
    technologies: ['Python', 'Backbone', 'Facebook API'],
    category: 'classic',
    image: '/assets/evangeler.webp',
  },
  {
    id: 'multiplicationmaster',
    title: 'Multiplication Master',
    subtitle: 'Education game',
    description: 'Math practice game built with Python, Bootstrap, JavaScript, and Google App Engine.',
    url: 'https://multiplicationmaster.com',
    technologies: ['Python', 'Bootstrap', 'Education'],
    category: 'classic',
    image: '/assets/multiplicationmaster.webp',
  },
  {
    id: 'addicting-word-games',
    title: 'Addicting Word Games',
    subtitle: 'Word game portal',
    description: 'Word-game portal built with Python, Bootstrap, JavaScript, and Google App Engine.',
    url: 'https://addictingwordgames.com',
    technologies: ['Python', 'Bootstrap', 'Word Games'],
    category: 'classic',
    image: '/assets/addicting-word-games.webp',
  },
  {
    id: 'joydrop',
    title: 'Joy Drop',
    subtitle: 'Kids creative app',
    description: 'Creative drag-and-drop app for kids, now being rebuilt with transparency-aware touch gestures and paid access.',
    url: 'https://joydrop.app.nz',
    technologies: ['JavaScript', 'Go', 'Touch UX'],
    category: 'classic',
    image: '/assets/joydrop.webp',
  },
  {
    id: 'wordsmashing',
    title: 'Word Smashing',
    subtitle: 'Word puzzle game',
    description: 'Word puzzle across Python, Bootstrap, JavaScript, App Engine, and browser/mobile packaging.',
    url: 'https://wordsmashing.v5games.com',
    technologies: ['Python', 'JavaScript', 'Game'],
    category: 'classic',
    image: '/assets/wordsmashing.webp',
  },
  {
    id: 'shoppingsmart',
    title: 'Shopping Smart',
    subtitle: 'NZ price comparison',
    description: 'Price-comparison product with ASP.NET, C#, MVC, ecommerce crawling, and marketplace-style data handling.',
    github: 'https://codex-infinity.com/lee101/shoppingsmart-old',
    technologies: ['ASP.NET', 'C#', 'Ecommerce'],
    category: 'classic',
    image: '/assets/shoppingsmart.webp',
  },
];

export const EXPERIENCE = [
  'Founder and builder of an applied AI product ecosystem across coding agents, model gateways, media generation, search, speech, data analysis, games, and infrastructure.',
  'Senior Machine Learning Engineer at Microsoft, Founding Machine Learning Engineer at Compose.ai YC W21, and Image Processing / ML Engineer at Canva.',
  'Earlier engineering across Fairfax Media, Weta Digital Motion R&D, .nz Registry Services, Infoxchange, 99designs, Kiwiplan, and the University of Auckland.',
];

export const INTERESTS = [
  'Machine learning, acceleration, CUDA/Triton kernels, model serving, embeddings, interpretability, and AI/human interaction.',
  'Search, data analytics, scientific tooling, big data systems, graphics, VFX, games, web systems, security, automation, and testing.',
];

export const CONTACT_EMAIL = 'lee.penkman@netwrck.com';
